import React from "react";
import { DropdownButton } from "@jsq/ds/core";
import { useScreeningReportDownload } from "./useScreeningReportDownload";

type Props = {
  arenaId: number;
  positionId: number;
  disabled?: boolean;
};

export const PositionActions = ({ arenaId, positionId, disabled = false }: Props) => {
  const { downloadScreeningReport, isLoading } = useScreeningReportDownload();

  const handleExportScreeningStatus = () => {
    void downloadScreeningReport({ arenaId, positionIds: [positionId] });
  };

  return (
    <DropdownButton
      data-testid="position-actions-dropdown"
      label="Actions"
      variant="muted"
      direction="down"
      align="right"
      disabled={disabled || isLoading}
      isLoading={isLoading}
    >
      <DropdownButton.Action
        data-testid="export-screening-status"
        onSelect={handleExportScreeningStatus}
      >
        Export screening status only
      </DropdownButton.Action>
    </DropdownButton>
  );
};
